module.exports = __webpack_public_path__ + "img/product_13.4bcebbc.svg";